/* eslint-disable no-unused-vars */
import { ProFormaModelIds } from 'constants/proForma';

export enum ColumnKeys {
    PERCENT_OF_INCOME = 'percentOfIncome',
    PRICE_PER_SF = 'pricePerSf',
    PRICE_PER_UNIT = 'pricePerUnit',
    PRICE_PER_RACK_PER_YEAR = 'pricePerRackPerYear',
    PRICE_PER_KW_PER_YEAR = 'pricePerKwPerYear',
}

export const COLUMN_KEYS_BY_MODEL_ID: Record<string, ColumnKeys[]> = {
    [ProFormaModelIds.APARTMENT]: [
        ColumnKeys.PERCENT_OF_INCOME,
        ColumnKeys.PRICE_PER_SF,
        ColumnKeys.PRICE_PER_UNIT,
    ],
    [ProFormaModelIds.APARTMENT_WITH_RETAIL]: [
        ColumnKeys.PERCENT_OF_INCOME,
        ColumnKeys.PRICE_PER_SF,
        ColumnKeys.PRICE_PER_UNIT,
    ],
    [ProFormaModelIds.RETAIL]: [
        ColumnKeys.PERCENT_OF_INCOME,
        ColumnKeys.PRICE_PER_SF,
    ],
    [ProFormaModelIds.OFFICE]: [
        ColumnKeys.PERCENT_OF_INCOME,
        ColumnKeys.PRICE_PER_SF,
    ],
    [ProFormaModelIds.INDUSTRIAL]: [
        ColumnKeys.PERCENT_OF_INCOME,
        ColumnKeys.PRICE_PER_SF,
    ],
    [ProFormaModelIds.DATA_CENTER]: [
        ColumnKeys.PERCENT_OF_INCOME,
        ColumnKeys.PRICE_PER_RACK_PER_YEAR,
        ColumnKeys.PRICE_PER_KW_PER_YEAR,
    ],
};
